import _toConsumableArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { rehype } from 'rehype';
import rehypePrism from 'rehype-prism-plus';
export var processHtml = function processHtml(html, plugins) {
  if (plugins === void 0) {
    plugins = [[rehypePrism, {
      ignoreMissing: true
    }]];
  }

  return rehype().data('settings', {
    fragment: true
  }).use(_toConsumableArray(plugins)).processSync("" + html).toString();
};
export function htmlEncode(sHtml) {
  return sHtml.replace(/```(tsx?|jsx?|html|xml)(.*)\s+([\s\S]*?)(\s.+)?```/g, function (str) {
    return str.replace(/[<&"]/g, function (c) {
      return {
        '<': '&lt;',
        '>': '&gt;',
        '&': '&amp;',
        '"': '&quot;'
      }[c];
    });
  }).replace(/[<&"]/g, function (c) {
    return {
      '<': '&lt;',
      '>': '&gt;',
      '&': '&amp;',
      '"': '&quot;'
    }[c];
  });
}
export function stopPropagation(e) {
  e.stopPropagation();
  e.preventDefault();
}